import { Duration } from 'date-fns';
import { match } from 'ts-pattern';

export const determineDurationField = (value: Duration) =>
  match(value)
    .returnType<[number, Intl.RelativeTimeFormatUnitSingular | 'justNow']>()
    .when(
      (d) => d.years && d.years > 0,
      (d) => [d.years ?? 0, 'year'],
    )
    .when(
      (d) => d.months && d.months > 0,
      (d) => [d.months ?? 0, 'month'],
    )
    .when(
      (d) => d.days && d.days > 0,
      (d) => [d.days ?? 0, 'day'],
    )
    .when(
      (d) => d.hours && d.hours > 0,
      (d) => [d.hours ?? 0, 'hour'],
    )
    .when(
      (d) => d.minutes && d.minutes > 0,
      (d) => [d.minutes ?? 0, 'minute'],
    )
    .otherwise(() => [0, 'justNow']);
